export default "__VITE_ASSET__D4pNnLOD__"